import SettingsIndex from './Index'
import SettingsUser from './user/Index'
import SettingsCompany from './company/Index'
import SettingsPriceList from './priceList/Index'
import SettingsApi from './Api'
import UserLogs from './userlog/Index'
import Downtime from './downtimes/Index'

export default [
  {
    path: '/settings',
    name: 'settings',
    component: SettingsIndex,
    redirect: '/settings/users',
    meta: {
      auth: true,
      permission: 'view',
    },
    children: [
      {
        path: 'users',
        name: 'users',
        component: SettingsUser,
      },
      {
        path: 'companies',
        name: 'companies',
        component: SettingsCompany,
      },
      {
        path: 'pricelist',
        name: 'pricelist',
        component: SettingsPriceList,
      },
      {
        path: 'api',
        name: 'settingsApi',
        component: SettingsApi,
      },
      {
        path: 'userlogs',
        name: 'userlogs',
        component: UserLogs,
      },
      {
        path: 'downtime',
        name: 'settingsDowntime',
        component: Downtime,
      },
    ],
  },
]
